import status from 'http-status'

import { history } from '../_helpers/history';

import { authenticationService } from '../_services/authentication.service';

import { authenticationConstants as constants } from '../_constants/authentication.constants';

import { userActions } from '../_actions/user.actions'
import { alertActions } from './alert.actions';
import { clientActions } from '../_actions/client.actions';
import { userService } from '../_services/user.service';

class AccountDomainError extends Error {
  constructor(msg) {
    super(msg);
    this.name = 'AccountDomainError';
  }
}

export const authenticationActions = {
  login,
  logout,
  clearAll,
  setToken,
  setPermissions,
};

function setPermissions(permissions) {
  return { type: constants.AUTH_SET_PERMISSIONS, permissions}
}

function setShowAccountDomain(accountData, authToken) {
  return { type: constants.AUTH_SHOW_ACCOUNT_DOMAIN, accountData, authToken }
}

function setToken(token) {
  return { type: constants.AUTH_SET_TOKEN, token }
}

function clearAll() {
  return { type: constants.AUTH_CLEAR }
}

function login(providerId, username, password, path) {
  let accountData;
  let authToken;

  return dispatch => {
    dispatch(request());

    authenticationService.login(providerId, username, password)
      .then(data => {
        accountData = data.client;
        authToken = data.authentication.access_token;

        if (data.client.accountDomain !== window.location.host) {
          throw new AccountDomainError()
        }

        dispatch(clientActions.setAccount(accountData));
        dispatch(setToken(authToken))

        return userService.me(authToken);
      })
      .then(userData => {
        dispatch(userActions.setCurrentUser(userData));
        dispatch(authenticationActions.setPermissions(userData.permissions));

        history.push(path)
      })
      .catch(error => {
        if (error.name === 'AccountDomainError') {
          window.location.replace(`https://${accountData.accountDomain}/login/refresh?auth=${authToken}&clientId=${accountData.id}`);
        } else if (error.response && (error.response.status === status.UNAUTHORIZED || error.response.status === status.UNPROCESSABLE_ENTITY)) {
          dispatch(failure());
          dispatch(alertActions.error('Invalid Login Credentials'));
        } else {
          dispatch(failure());
          dispatch(alertActions.error('Could not log you in at this time. Please try again later.'));
        }
      });
  };

  function request() { return { type: constants.AUTH_LOGIN_REQUEST } }
  function failure() { return { type: constants.AUTH_LOGIN_FAILURE } }
}

function logout() {
  return dispatch => {
    localStorage.removeItem('dashboardLocation')

    authenticationService.logout()
      .catch(() => {
        history.push('/login');
      })
      .then(() => {
        history.push('/login');
      });
  }
}